/* unplugin-vue-components disabled */const { ref, getCurrentInstance, inject, watchEffect } = require('vue');
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = n => ((0, vue_2.pushScopeId)("data-v-16e33928"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "top-button" };
const _hoisted_2 = _withScopeId(() => (0, vue_2.createElementVNode)("span", null, "导入模型", -1));
const _hoisted_3 = _withScopeId(() => (0, vue_2.createElementVNode)("span", null, "新建坐标系", -1));
const _hoisted_4 = { class: "down-tree" };
const _hoisted_5 = ["onMouseover", "onMouseleave"];
const _hoisted_6 = { key: 0 };
const _hoisted_7 = ["onClick"];
const index_vue_1 = tslib_1.__importDefault(require("@/components/DeviceDialg/index.vue"));
const vue_3 = require("vue");
const work_1 = require("@/store/modules/work");
const model_1 = require("@/model");
const index_vue_2 = tslib_1.__importDefault(require("@/components/RightMenu/index.vue"));
const user_1 = require("@/service/user");
exports.default = (0, vue_1.defineComponent)({
    __name: 'index',
    setup(__props) {
        const store = (0, work_1.useWork)();
        const curNode = (0, vue_3.computed)(() => store.curNode);
        const isShowing = ref('');
        const { proxy, refs } = getCurrentInstance();
        const workStore = (0, work_1.useWork)();
        const elTreeData = (0, vue_3.computed)(() => {
            var _a;
            let treeData = [];
            (_a = model_1.Project.current()) === null || _a === void 0 ? void 0 : _a.machines.forEach((e) => {
                let node;
                if (e.type == model_1.ENTITY_TYPE.ROBOT) {
                    let robot = e;
                    node = { label: `${e.name} ${e.model.name}`, id: e.id, rootId: e.id, type: e.type };
                    node.children = [];
                    node.children.push(createPathsNode(robot));
                    node.children.push(createToolNode(robot));
                    node.children.push(createTool0Node(robot));
                    user_1.permService.hasProgram().then(() => node.children.push(createProgramNode(robot)));
                }
                else if (e.type === model_1.ENTITY_TYPE.TOOL) {
                    node = {
                        label: `${e.name} ${e.type}`,
                        id: e.id,
                        rootId: e.id,
                        type: e.type,
                        children: [createTool0Node(e)]
                    };
                }
                else {
                    node = { label: `${e.name} ${e.type}`, id: e.id, rootId: e.id, type: e.type };
                }
                treeData.push(node);
            });
            return treeData;
        });
        function createProgramNode(e) {
            let programsNode = {
                label: model_1.DEVICE_TYPE_NAME.Program,
                rootId: e.id,
                id: e.id + work_1.VIR_NODE_TYPE.N_PROGRAM,
                type: work_1.VIR_NODE_TYPE.N_PROGRAM
            };
            return programsNode;
        }
        function createTool0Node(e) {
            let tool0Node = {
                label: model_1.DEVICE_TYPE_NAME.Tool0,
                rootId: e.id,
                id: e.id + work_1.VIR_NODE_TYPE.N_TCP,
                type: work_1.VIR_NODE_TYPE.N_TCP
            };
            if (e.tcps) {
                let childs = [];
                for (let i = 0; i < e.tcps.length; i++) {
                    let tcp = e.tcps[i];
                    if (tcp.reference.frame === 'rp')
                        continue;
                    let node = { label: tcp.name, rootId: e.id, id: tcp.id, type: work_1.NODE_TYPE.TCP };
                    childs.push(node);
                }
                tool0Node.children = childs;
            }
            return tool0Node;
        }
        function createToolNode(e) {
            let toolNode = {
                label: model_1.DEVICE_TYPE_NAME.Tool,
                rootId: e.id,
                id: e.id + work_1.VIR_NODE_TYPE.N_TAIL,
                type: work_1.VIR_NODE_TYPE.N_TAIL
            };
            if (e.tool) {
                toolNode.label = `${toolNode.label} (${e.tool.name})`;
                toolNode.type = work_1.NODE_TYPE.TOOL;
                toolNode.id = e.tool.id;
            }
            return toolNode;
        }
        function createPathsNode(e) {
            let paths = e.paths;
            let pathsNode = {
                label: model_1.DEVICE_TYPE_NAME.Path,
                rootId: e.id,
                id: e.id + work_1.VIR_NODE_TYPE.N_PATH,
                type: work_1.VIR_NODE_TYPE.N_PATH
            };
            pathsNode.children = paths.filter(path => path.type === 'path').map((path) => {
                let pathNode = { label: path.name, rootId: e.id, id: path.id, type: work_1.NODE_TYPE.PATH };
                return pathNode;
            });
            return pathsNode;
        }
        function createRightMenuData(node) {
            var _a;
            if (node.type === work_1.NODE_TYPE.ROBOT || node.type === work_1.NODE_TYPE.UCS || node.type === work_1.NODE_TYPE.DEVICE) {
                let menus = new Array();
                if (node.type === work_1.NODE_TYPE.ROBOT) {
                    let target = model_1.Project.current().findTargetById(node.rootId);
                    let isHidden = target.isHidden;
                    menus.push({
                        label: isHidden ? '显示' : '隐藏',
                        id: node.id,
                        onClick: (command) => {
                            model_1.Project.current().hideMachine(command.id, !isHidden);
                        }
                    });
                }
                menus.push({
                    label: '删除',
                    confirmMsg: `确定删除"${node.label}"吗？`,
                    id: node.id,
                    onClick: (command) => {
                        model_1.Project.current().removeMachine(command.id);
                        store.selectNode(null);
                    }
                });
                return menus;
            }
            else if (node.type === work_1.NODE_TYPE.TCP) {
                let robot = (_a = model_1.Project.current()) === null || _a === void 0 ? void 0 : _a.findMachineById(node.id);
                let res = [];
                if (robot.tcp0.id !== node.id) {
                    res.push({
                        label: '删除',
                        id: node.id,
                        onClick: (command) => {
                            store.curDevice.delTcp(command.id);
                            store.selectNode(null);
                        }
                    });
                }
                return res;
            }
            else if (node.type === work_1.NODE_TYPE.PATH) {
                return [{
                        label: '删除',
                        confirmMsg: `确定删除"${node.label}"吗？`,
                        id: node.id,
                        onClick: (command) => {
                            store.curDevice.delPath(command.id);
                            store.selectNode(null);
                        }
                    }];
            }
            else if (node.type === work_1.VIR_NODE_TYPE.N_TAIL) {
            }
            else if (node.type === work_1.NODE_TYPE.TOOL) {
            }
            return [];
        }
        const openDeviceTree = ref(true);
        function handleDeviceTree() {
            openDeviceTree.value = !openDeviceTree.value;
            setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
            }, 200);
        }
        let id = 1000;
        function icon(type) {
            switch (type) {
                case work_1.NODE_TYPE.ROBOT:
                    return 'node-robot';
                case work_1.NODE_TYPE.DEVICE:
                    return 'node-device';
                case work_1.VIR_NODE_TYPE.N_TCP:
                case work_1.NODE_TYPE.TCP:
                    return 'node-point';
                case work_1.VIR_NODE_TYPE.N_TAIL:
                    return 'node-tool';
                case work_1.VIR_NODE_TYPE.N_PATH:
                case work_1.NODE_TYPE.PATH:
                    return 'icon-path';
                case work_1.VIR_NODE_TYPE.N_PROGRAM:
                    return 'block';
                case work_1.NODE_TYPE.UCS:
                    return 'node-point';
                default:
                    return 'node-others';
            }
        }
        const append = (data) => {
            const newChild = { id: id++, label: 'testtest', children: [] };
            if (!data.children) {
                data.children = [];
            }
            data.children.push(newChild);
        };
        const remove = (node, data) => {
            const parent = node.parent;
            const children = parent.data.children || parent.data;
            const index = children.findIndex((d) => d.id === data.id);
            children.splice(index, 1);
        };
        const dialog = ref(index_vue_1.default);
        function onClickAdd3DBtn() {
            dialog.value.show();
        }
        function onClickCoordinateCreate() {
            var _a;
            let ucs = model_1.Project.current().createUcs(null, false);
            [ucs.pr.x, ucs.pr.y, ucs.pr.z] = [(2 + 8 * Math.random()) * 100, (-2 - 8 * Math.random()) * 100, (2 + 8 * Math.random()) * 100];
            (_a = model_1.Project.current()) === null || _a === void 0 ? void 0 : _a.addMachine(ucs);
            store.selectNode(ucs);
        }
        const deviceTree = ref();
        const onLeftBarSelect = inject('onLeftBarSelect');
        function handleNodeClick(treeData) {
            var _a;
            if (treeData.type === work_1.VIR_NODE_TYPE.N_PROGRAM) {
                let robot = (_a = model_1.Project.current()) === null || _a === void 0 ? void 0 : _a.findMachineById(treeData.rootId);
                model_1.Project.current().selectProgram(treeData.rootId, robot.code.programs.find(e => e.name === "主程序").id);
                onLeftBarSelect('program');
                return;
            }
            store.selectNode(treeData);
            isShowing.value = treeData.id;
        }
        watchEffect(() => {
            if (deviceTree.value && workStore.curNode) {
                deviceTree.value.setCurrentKey(workStore.curNode.target.id, true);
            }
        });
        return (_ctx, _cache) => {
            const _component_svg_icon = (0, vue_2.resolveComponent)("svg-icon");
            const _component_el_button = (0, vue_2.resolveComponent)("el-button");
            const _component_el_tree = (0, vue_2.resolveComponent)("el-tree");
            const _component_el_icon = (0, vue_2.resolveComponent)("el-icon");
            const _component_el_affix = (0, vue_2.resolveComponent)("el-affix");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createElementVNode)("div", {
                    class: (0, vue_2.normalizeClass)({ 'device-tree': (0, vue_2.unref)(openDeviceTree), 'device-tree-close': !(0, vue_2.unref)(openDeviceTree) })
                }, [
                    (0, vue_2.createElementVNode)("div", _hoisted_1, [
                        (0, vue_2.createVNode)(_component_el_button, {
                            type: "primary",
                            size: "small",
                            plain: "",
                            onClick: onClickAdd3DBtn
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(_component_svg_icon, { "icon-class": "node-3d" }),
                                _hoisted_2
                            ]),
                            _: 1
                        }),
                        (0, vue_2.createVNode)(_component_el_button, {
                            type: "primary",
                            size: "small",
                            plain: "",
                            onClick: onClickCoordinateCreate,
                            style: { "visibility": "hidden" }
                        }, {
                            default: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createVNode)(_component_svg_icon, { "icon-class": "node-point" }),
                                _hoisted_3
                            ]),
                            _: 1
                        })
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        (0, vue_2.createVNode)(_component_el_tree, {
                            data: elTreeData.value,
                            "node-key": "id",
                            "default-expand-all": "",
                            "expand-on-click-node": false,
                            class: "tree-border",
                            "highlight-current": true,
                            onCurrentChange: handleNodeClick,
                            ref_key: "deviceTree",
                            ref: deviceTree
                        }, {
                            default: (0, vue_2.withCtx)(({ node, data }) => [
                                (0, vue_2.createElementVNode)("span", {
                                    class: "custom-tree-node",
                                    onMouseover: ($event) => { data.mouseover = true; },
                                    onMouseleave: ($event) => (data.mouseover = false)
                                }, [
                                    (data.type !== (0, vue_2.unref)(work_1.NODE_TYPE).ROBOT)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_6, [
                                            (0, vue_2.createVNode)(_component_svg_icon, {
                                                class: "icon",
                                                "icon-class": icon(data.type)
                                            }, null, 8, ["icon-class"]),
                                            (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(node.label), 1)
                                        ]))
                                        : ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(index_vue_2.default, {
                                            key: 1,
                                            data: createRightMenuData(data),
                                            onClickIcon: ($event) => (isShowing.value = data.id)
                                        }, {
                                            default: (0, vue_2.withCtx)(() => [
                                                (0, vue_2.createElementVNode)("div", {
                                                    style: { "width": "100%" },
                                                    onClick: ($event) => (handleNodeClick(data))
                                                }, [
                                                    (0, vue_2.createVNode)(_component_svg_icon, {
                                                        class: "icon",
                                                        "icon-class": icon(data.type)
                                                    }, null, 8, ["icon-class"]),
                                                    (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(node.label), 1)
                                                ], 8, _hoisted_7)
                                            ]),
                                            _: 2
                                        }, 1032, ["data", "onClickIcon"]))
                                ], 40, _hoisted_5)
                            ]),
                            _: 1
                        }, 8, ["data"])
                    ]),
                    (0, vue_2.createVNode)(_component_el_affix, {
                        position: "bottom",
                        offset: 0,
                        style: { "position": "relative", "left": "100%", "top": "-50%" }
                    }, {
                        default: (0, vue_2.withCtx)(() => [
                            (0, vue_2.createVNode)(_component_el_icon, {
                                size: "30px",
                                style: { "width": "30px" },
                                onClick: handleDeviceTree
                            }, {
                                default: (0, vue_2.withCtx)(() => [
                                    (0, vue_2.createVNode)(_component_svg_icon, {
                                        "icon-class": (0, vue_2.unref)(openDeviceTree) ? 'angle-double-left' : 'angle-double-right'
                                    }, null, 8, ["icon-class"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ], 2),
                (0, vue_2.createVNode)(index_vue_1.default, {
                    ref_key: "dialog",
                    ref: dialog,
                    showTypes: [(0, vue_2.unref)(model_1.MODEL_TYPE).ROBOT, (0, vue_2.unref)(model_1.MODEL_TYPE).TOOL, (0, vue_2.unref)(model_1.MODEL_TYPE).DEVICE],
                    isImportScene: true
                }, null, 8, ["showTypes"])
            ], 64));
        };
    }
});
